 var addtocart_selector = '';
 var variant_dropdown_selector = '';
 var qty_selector ='';
 var enable_pvt_app = 'yes';
 var show_floating_cart = 'no';
 var show_tbl_after_customer_logged_in = 'no';
 var redirect_cart_page = 'no';
 var hide_price = 'no';
 var hide_price_text = 'Call for price';
 var hide_add_to_cart_btn = 'no';
 var hide_variant_dropdowns = 'no';
 var hide_qty_box = 'no';
 var show_out_of_stock = 'yes';
 var currency_code_included = 'yes';
 var default_qty_val = '0';
 var single_atc_status = 'YES';
 var variant_img_size = 'small';
 var enable_filter = 'no';
 var in_stock_txt = 'En stock';
 var out_of_stock_txt = 'Rupture de stock';
 var price_txt = 'Prix TTC';
 var qty_txt = 'Qté';
 var added_btn_text='Ajouté';
 var adding_btn_text='Ajout';
 var add_more_btn_text='Ajouter plus ...';
 var thank_you_btn_text='Ajouté';
 var bulk_add_to_cart_text = 'Ajouter sélection au panier';
 var add_to_cart_text = 'Ajouter au panier';
 var stock_alert='Il n\'en reste que %s';
 var modal_header_txt = 'Votre panier contient %s produits';
 var product_name = 'Modèle';
 var modal_subtotal_txt='Sous-total ( HT )';
 var modal_viewbtn_txt='Voir mon panier';
 var modal_contbtn_txt='Continuer mes achats';
 var error1_text1='Vous ne pouvez ajouter que';
 var error1_text2='à votre panier.';
 var error2_text1='Tous les';
 var error2_text2='sont dans votre panier.';
 var error3_text1='Vous ne pouvez ajouter';
 var show_in_stock_text='no';